import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Plus, Trash, UploadSimple, X } from "@phosphor-icons/react";

export default function AdminSlider() {
  const [list, setList] = useState([]);
  const refresh = () => api.get("/admin/slides").then((r) => setList(r.data || []));
  useEffect(() => { refresh(); }, []);

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const fd = new FormData();
      fd.append("file", file);
      const up = await api.post("/admin/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.post("/admin/slides", { image_url: up.data.url, caption: "", link_url: "", order: list.length, is_active: true });
      toast.success("Slide added");
      refresh();
    } catch { toast.error("Upload failed"); }
  };

  const del = async (id) => {
    if (!window.confirm("Delete this slide?")) return;
    await api.delete(`/admin/slides/${id}`);
    refresh();
  };

  const toggleActive = async (s) => {
    await api.put(`/admin/slides/${s.id}`, { ...s, is_active: !s.is_active });
    refresh();
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display font-bold text-3xl md:text-4xl">Slider Images</h1>
          <p className="text-[#56624F] mt-1">Hero banners & featured imagery on the public pages</p>
        </div>
        <label className="btn-primary inline-flex items-center gap-2 cursor-pointer" data-testid="add-slide-btn">
          <UploadSimple size={16} /> Upload Slide
          <input type="file" accept="image/*" className="hidden" onChange={upload} />
        </label>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((s) => (
          <div key={s.id} className="seva-card !p-0 overflow-hidden" data-testid={`slide-${s.id}`}>
            <div className="aspect-video bg-[#EEF4E9]">
              <img src={s.image_url} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="p-4 flex items-center justify-between">
              <label className="text-xs text-[#56624F] flex items-center gap-2">
                <input type="checkbox" checked={s.is_active} onChange={() => toggleActive(s)} />
                {s.is_active ? "Active" : "Hidden"}
              </label>
              <button onClick={() => del(s.id)} className="text-[#B84A34] p-2 hover:bg-[#EEF4E9] rounded-lg"><Trash size={16} /></button>
            </div>
          </div>
        ))}
        {!list.length && <div className="col-span-full seva-card text-center text-[#56624F]">No slides yet. Upload one to get started.</div>}
      </div>
    </div>
  );
}
